<script>
import Translate from '@wielink-application/translation/vue/translation/translate.vue'
export default Translate;
</script>